export default "__VITE_ASSET__DpPSuaJr__"